import React from 'react';

import ApprovalsIndex from "./index"


export default [
	{ path: '/approvals', component: ApprovalsIndex, name: 'Approvals' },
]

// import ApprovalsRoutes from "modules/approvals/mobile/routes"
// routes = _.concat(routes,ApprovalsRoutes)
